import { render, staticRenderFns } from "./RadioInput.vue?vue&type=template&id=2055391d"
import script from "./RadioInput.vue?vue&type=script&lang=js"
export * from "./RadioInput.vue?vue&type=script&lang=js"
import style0 from "./RadioInput.vue?vue&type=style&index=0&id=2055391d&prod&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports